import React, { ReactNode } from 'react'
import Box from '../primitives/Box'

export function VisuallyHidden({ children }: { children: ReactNode }) {
  return (
    <Box
      css={`
        clip: rect(0 0 0 0);
        clip-path: inset(50%);
        height: 1px;
        overflow: hidden;
        position: absolute;
        white-space: nowrap;
        width: 1px;
      `}
    >
      {children}
    </Box>
  )
}
